import { createContext } from "react";

const ControllerContext = createContext();

export default ControllerContext ;
